{
  "definitions": {
    "intro": "商品フォームに追加する項目です（長めの説明、発売年など）。ここで追加すると、商品フォームにすぐ表示されます。",
    "add": "追加項目をつくる",
    "new_title": "新しい追加項目",
    "drawer_hint": "スタッフが商品ページで入力する内容です。商品で使うまでサイトには出ません。",
    "save": "項目を保存",
    "saved": "「{{name}}」を保存しました — 商品フォームに表示されます",
    "deleted": "「{{name}}」を削除しました",
    "delete": "削除",
    "delete_title": "「{{name}}」を削除しますか？",
    "delete_consequence": "商品フォームからこの欄が消えます。すでに値が入っている商品がある場合は削除されません。",
    "in_use_title": "この項目はまだ使われています",
    "in_use_body_other": "{{count}} 件の商品にこの項目の値が入っているため、削除しませんでした。先にその商品の値を消してください。",
    "in_use_ok": "OK",
    "type_in_use_other": "{{count}} 件の商品に値が入っているため、答えの種類は変更できません。元の種類のままにするか、新しい項目をつくってください。",
    "type_change_warning": "答えの種類を変更しようとしています。すでに値が入っている商品があると、変更は受け付けられず件数が表示されます。",
    "duplicate_key": "このコード名の項目はすでにあります。別のコード名にしてください。",
    "all_types": "すべての種類",
    "position_cell": "{{position}}（フォームの {{part}} 番）",
    "columns": {
      "label": "名前",
      "key": "コード名",
      "type": "答えの種類",
      "owner": "対象",
      "position": "フォーム内の位置",
      "applies_to": "表示する商品",
      "ebay": "eBay での名前"
    },
    "flags_short": {
      "filterable": "サイトで絞り込み",
      "searchable": "検索対象",
      "showOnStorefront": "サイトに表示"
    },
    "flags": {
      "filterable": "お客様がサイトでこの項目で絞り込める",
      "searchable": "サイトの検索でこの項目から商品が見つかる",
      "showOnStorefront": "サイトの商品ページに表示する"
    },
    "fields": {
      "label_en": "名前（英語）",
      "label_en_hint": "入力欄の上に出る名前です（例: Detail）。",
      "label_ja": "名前（日本語）",
      "label_th": "名前（タイ語）",
      "label_zh-Hant": "名前（中国語・繁体字）",
      "label_zh-Hans": "名前（中国語・簡体字）",
      "key": "コード名",
      "key_hint": "英語の名前から自動で入ります。{{key}} として保存され、取り込みファイルで使います。",
      "key_locked": "保存後はコード名を変更できません（ファイルや商品で使われています）。",
      "owner": "対象",
      "type": "答えの種類",
      "position": "商品フォーム内の位置",
      "position_hint": "数字で入力。5 = サブカテゴリの隣、それ以外 = {{part}} 番「詳細」の中。小さい数字ほど上に出ます。",
      "position_hint_other": "数字で入力。小さい数字ほど上に出ます。",
      "applies_to": "この種類の商品に表示",
      "applies_to_hint": "何も選ばない = すべての種類。",
      "use": "サイトでの使い方",
      "rules": "答えのルール",
      "ebay_aspect": "eBay での名前（今後用）",
      "ebay_aspect_hint": "今後 eBay とつなぐときのために保存するだけです。今は何も送りません。"
    },
    "owners": {
      "product": "商品",
      "variant": "商品の選択肢ごと（BOX・パックなど）",
      "collection": "コレクションページ"
    },
    "types": {
      "single_line_text": "短い文字（1行）",
      "multi_line_text": "長い文字（複数行）",
      "rich_text": "書式つきの文字（太字・箇条書き）",
      "integer": "整数",
      "decimal": "小数つきの数字",
      "boolean": "はい / いいえ",
      "date": "日付",
      "url": "ウェブのリンク",
      "json": "構造化データ（上級者向け）",
      "list_text": "短い文字のリスト",
      "file_reference": "ファイル・画像 1つ",
      "list_file_reference": "ファイル・画像 複数",
      "reference": "別の商品へのリンク"
    },
    "rules": {
      "required": "入力しないと商品を保存できない",
      "choices": "選べる答え",
      "choices_hint": "1行に1つ。空欄なら自由に入力できます。",
      "min": "最小の数字",
      "max": "最大の数字",
      "max_length": "最大の文字数",
      "regex": "文字の形式（パターン）",
      "regex_hint": "上級者向け — わからなければ空欄のままで。",
      "max_items": "リストの最大件数"
    },
    "problems": {
      "required": "入力してください。",
      "key_format": "半角の小文字 a–z・数字・_ だけを使い、先頭は文字にしてください。",
      "position_range": "0〜999 の数字にしてください。",
      "not_number": "数字で入力してください（例: 8）。",
      "min_above_max": "最大の数字は最小の数字より小さくできません。",
      "not_whole": "整数で入力してください（例: 200）。",
      "pattern_invalid": "このパターンは読み取れません。わからなければ空欄にしてください。",
      "choices_not_whole": "選べる答えはすべて整数にしてください。"
    }
  },
  "categories": {
    "intro": "サイトの商品のグループです（最大3階層。例: 未開封商品 › BOX）。順番は ▲ ▼ で変えられます。",
    "add": "カテゴリを追加",
    "new_title": "新しいカテゴリ",
    "save": "カテゴリを保存",
    "saved": "カテゴリ「{{name}}」を保存しました",
    "deleted": "カテゴリ「{{name}}」を削除しました",
    "delete": "削除",
    "delete_title": "カテゴリ「{{name}}」を削除しますか？",
    "delete_consequence": "サイトのメニューからカテゴリが消えます。商品やサブカテゴリが残っているカテゴリは削除されません。",
    "in_use_title": "このカテゴリはまだ使われています",
    "in_use_body": "商品が {{products}} 件、サブカテゴリが {{children}} 件あります。先に別のカテゴリへ移すか、削除せずに非表示にしてください。",
    "too_deep": "カテゴリは最大 {{max}} 階層までです。もっと上の親を選んでください。",
    "duplicate": "ほかのカテゴリがこのURL名を使っています。少し変えてください。",
    "top_level": "— いちばん上（親なし） —",
    "shown": "表示中",
    "hidden": "非表示",
    "move_up": "{{name}} を上へ",
    "move_down": "{{name}} を下へ",
    "add_child": "{{name}} の下にカテゴリを追加",
    "columns": {
      "name": "名前",
      "slug": "URL に使う名前",
      "applies_to": "対象",
      "active": "サイト表示",
      "order": "順番"
    },
    "fields": {
      "name_en": "名前（英語）",
      "name_ja": "名前（日本語）",
      "name_th": "名前（タイ語）",
      "name_zh-Hant": "名前（中国語・繁体字）",
      "name_zh-Hans": "名前（中国語・簡体字）",
      "slug": "URL に使う名前",
      "slug_hint": "英語の名前から自動で入ります: …/collections/{{name}}",
      "parent": "どのカテゴリの中に入れるか",
      "parent_hint": "大きなカテゴリなら「いちばん上」のままにします。",
      "applies_to": "この種類の商品が対象",
      "applies_to_hint": "商品フォームでは選んだ種類の商品にだけこのカテゴリが出ます。何も選ばない = すべて。",
      "active": "このカテゴリをサイトに表示する"
    },
    "problems": {
      "required": "入力してください。",
      "slug_format": "半角の小文字 a–z・数字・- だけを使ってください（スペース不可）。"
    }
  },
  "brands": {
    "intro": "商品のメーカー（スリーブ、デッキケースなど）とロゴです。",
    "add": "ブランドを追加",
    "new_title": "新しいブランド",
    "save": "ブランドを保存",
    "saved": "ブランド「{{name}}」を保存しました",
    "deleted": "ブランド「{{name}}」を削除しました",
    "delete": "削除",
    "delete_title": "ブランド「{{name}}」を削除しますか？",
    "delete_consequence": "ブランドが消えます。商品で使われているブランドは削除されません。",
    "in_use_title": "このブランドはまだ使われています",
    "in_use_body_other": "{{count}} 件の商品がこのブランドを使っているため、削除しませんでした。",
    "duplicate": "この URL 名のブランドはすでにあります。",
    "has_logo": "ロゴあり",
    "no_logo": "ロゴなし",
    "updated": "最終更新",
    "fields": {
      "name": "ブランド名",
      "logo": "ロゴ"
    }
  }
}
